/* eslint-disable @typescript-eslint/naming-convention -- Old names, file will be removed after typescript rewrite */

/** @deprecated Use `companyColors` instead. */
export const ColorTypes = [
  'blue-darker',
  'blue-dark',
  'blue',
  'blue-light',
  'blue-lighter',
  'blue-lightest',
  'coral-darker',
  'coral-dark',
  'coral',
  'coral-light',
  'coral-lighter',
  'coral-lightest',
  'mint-darker',
  'mint-dark',
  'mint',
  'mint-light',
  'mint-lighter',
  'mint-lightest',
  'rose-darker',
  'rose-dark',
  'rose',
  'rose-light',
  'rose-lighter',
  'rose-lightest',
  'yellow-darker',
  'yellow-dark',
  'yellow',
  'yellow-light',
  'yellow-lighter',
  'yellow-lightest',
  'success',
  'success-light',
  'info',
  'info-light',
  'warning',
  'warning-light',
  'danger',
  'danger-light',
  'neutral-100',
  'neutral-80',
  'neutral-70',
  'neutral-60',
  'neutral-40',
  'neutral-30',
  'neutral-20',
  'neutral-15',
  'neutral-10',
  'neutral-5',
  'neutral-3',
  'transparent',
  'white',
  'black',
  'current',
  '',
]

/** @deprecated Use `headlineTags` instead. */
export const HeadlineTagTypes = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  '',
]

/** @deprecated Use `iconNames` instead. */
export const IconNameTypes = [
  'add-line',
  'arrow-down-line',
  'arrow-left-line',
  'arrow-right-line',
  'arrow-up-line',
  'bulk-edit-line',
  'calender-line',
  'cardboard-box',
  'check-line',
  'checkmark-line',
  'chevron-down-line',
  'chevron-left-line',
  'chevron-right-line',
  'chevron-up-line',
  'clock-line',
  'clock-line-1',
  'close-line',
  'conversation-line',
  'curabox-glove-line',
  'curabox-material-line',
  'delete-line',
  'download-line',
  'edit-line',
  'elipses-line',
  'envelope-line',
  'error-fill',
  'error-line',
  'filter-line',
  'heart-fill',
  'heart-line',
  'help-fill',
  'help-line',
  'hide-line',
  'info-fill',
  'info-line',
  'icon-success',
  'loadingspinner-line',
  'login-line',
  'logout-line',
  'menu-line',
  'pause-line',
  'phone-line',
  'profile-line',
  'reload-line',
  'remove-line',
  'reset-line',
  'search-line',
  'settings-line',
  'shoppingbasket-line',
  'shoppingcart-line',
  'show-line',
  'start-line',
  'success-line',
  'success-fill',
  'upload-line',
  'warning-fill',
  'warning-line',
  'curabox-O',
]

const postions = [
  'left',
  'right',
  '',
]

/** @deprecated Use `horizontalPostions` instead. */
export const IconPositionTypes = [
  ...postions,
]

/** @deprecated Use `buttonTypes` instead. */
export const ButtonTypes = [
  'primary',
  'secondary',
  'text',
]

/** @deprecated Use `textAlignments` instead. */
export const TextAlignTypes = [
  ...postions,
  'center',
  'justify',
]

/** @deprecated Use `elementAlignments` instead. */
export const ElementAlignTypes = [
  'start',
  'flex-start',
  'center',
  'justify,',
  'end',
  'flex-end',
  'space-between',
  '',
]

/** @deprecated Use `verticalPositions` instead. */
export const BlockPositionTypes = [
  'top',
  'bottom',
  '',
]

/** @deprecated Use `viewportElements` instead. */
export const ViewportElements = {
  desktop: 3,
  tablet: 2,
}

/** @deprecated Use `viewPorts` instead. */
export const ViewPorts = {
  breakpointS: 576,
  breakpointM: 810,
  breakpointL: 1024,
}
